module.exports = __webpack_public_path__ + "static/media/mda_image.e9276733.png";